import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const SITE_URL = "https://commercialsolarroi.com";

function setMeta(selector, attr, value, content) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, value);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

/** Per-route title, description and canonical URL. */
export default function Seo({ title, description, noindex }) {
  const { pathname } = useLocation();
  useEffect(() => {
    if (title) document.title = title;
    if (description) setMeta('meta[name="description"]', "name", "description", description);
    const robots = noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1";
    setMeta('meta[name="robots"]', "name", "robots", robots);
    const path = pathname === "/" ? "" : pathname;
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    if (noindex) {
      canonical.removeAttribute("href");
    } else {
      canonical.setAttribute("href", `${SITE_URL}${path}`);
    }
    setMeta('meta[property="og:url"]', "property", "og:url", `${SITE_URL}${path}`);
  }, [title, description, noindex, pathname]);
  return null;
}
